import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M19.293 6.33 13.622 12l5.67 5.67a1 1 0 0 1 0 1.415l-.207.208a1 1 0 0 1-1.414 0L12 13.622l-5.67 5.67a1 1 0 0 1-1.415 0l-.208-.207a1 1 0 0 1 0-1.414L10.378 12l-5.67-5.67a1 1 0 0 1 0-1.415l.207-.208a1 1 0 0 1 1.414 0L12 10.378l5.67-5.67a1 1 0 0 1 1.415 0l.208.207a1 1 0 0 1 0 1.414Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol